module.exports = __webpack_public_path__ + "img/icone-activities-list.1de3137e.svg";